import { ProductsState } from "@/types";

export class ProductType {
  public static DRONE = new ProductType('drone', 'drones', 'ClassicIcon');
  public static CENTRAL_BODY = new ProductType('central_body', 'centralBodies', 'ClassicIcon');
  public static PAYLOAD = new ProductType('payload', 'accessories', 'SodaIcon');
  public static SPARE_PART = new ProductType('spare_part', 'spareParts', 'SodaIcon');
  public static SOFTWARE = new ProductType('software', 'software', 'eMotion');

  private static values: ProductType[] = [ProductType.DRONE, ProductType.CENTRAL_BODY, ProductType.PAYLOAD, ProductType.SPARE_PART, ProductType.SOFTWARE];

  private readonly _name: string;
  private readonly _stateField: keyof ProductsState;
  private readonly _defaultIcon: string;

  private constructor(name: string, stateField: keyof ProductsState, defaultIcon: string) {
    this._name = name;
    this._stateField = stateField;
    this._defaultIcon = defaultIcon;
  }

  get name(): string {
    return this._name;
  }

  get stateField(): keyof ProductsState {
    return this._stateField;
  }

  get defaultIcon(): string {
    return this._defaultIcon;
  }

  static of(name: string): ProductType | undefined {
    return this.values.find(t => name === t._name);
  }

}


// WEBPACK FOOTER //
// ./src/constants/productTypes.ts